import React from 'react'
import Jumbotron from 'components/Toko_Reseller/jumbotron'
import Kategori from 'components/Toko_Reseller/kategori'
import FlashSale from 'components/Toko_Reseller/flash_sale'
import Produk from 'components/Toko_Reseller/produk'

export default function toko_reseller() {
    return (
        <>
            <Jumbotron />
            <Kategori />
            <FlashSale />
            <Produk />
        </>
    )
}
